<script setup lang="ts">
import {
  DataTypeInfoDto,
  EvaluationParameterDto,
  instanceOfNumericEvaluationParameterDto,
} from '@/api/generator';
import FormLabel from '@/components/FormLabel/FormLabel.vue';
import { translateEntityProperty } from '@/utils/helper';

interface EnumOrQuantityLabelProps {
  data?: DataTypeInfoDto | EvaluationParameterDto;
  label?: string;
}

defineProps<EnumOrQuantityLabelProps>();
</script>

<template>
  <FormLabel v-if="data && data.iuid?.length" :for="data.id" :label="label ? label : $t('Name')">
    <div
      data-testid="FormInputDisplay"
      class="text-primary-darken-2 display d-flex justify-space-between"
    >
      <div class="flex-grow-1 text-body-1" :class="$attrs.class">
        <span class="font-weight-semibold">
          {{ translateEntityProperty('name', data) }}

          <template v-if="instanceOfNumericEvaluationParameterDto(data)">
            {{ translateEntityProperty('name', data.geometry) }}
          </template>
        </span>
        |
        {{ data.iuid }}
      </div>
    </div>
  </FormLabel>
</template>
